import React from 'react';
import {
  RouteProps
} from "react-router-dom";

interface Props {
  hasNext: boolean;
  toNext: Function;
}

const Pagination = (props: Props & RouteProps) => {
  const { hasNext, toNext } = props;
  const onClickNext = (e: any) => {
    e.preventDefault();
    toNext();
  }
  return (
    <nav>
      <ul className="pagination">
        {hasNext &&
          <li className="page-item">
            <a onClick={(e) => onClickNext(e)} className="page-link">次へ</a>
          </li>
        }
      </ul>
    </nav>
  )
}

export default Pagination;
